import misRutas from 'vue-routes-generator'
import GestionEmisorasComponent from './index.vue'
import GestionBloquesComponent from './componentes/bloques/bloques'
import GestionEmisorasEmisoraComponent from './componentes/emisoras/emisoras'
import GestionContenidosComponent from './componentes/contenidos/contenidos'
import GestionProgramasComponent from './componentes/programas/programas'

export default {
	install: Vue => {
		misRutas.route('/main').child('panel-control').child('gestion-emisoras', {
			name: 'Gestión de emisiones',
			component: GestionEmisorasComponent
		})

		misRutas.route('/main').child('panel-control').child('gestion-emisoras').child('emisoras', {
			name: 'Gestión de emisoras',
			component: GestionEmisorasEmisoraComponent
		})

		misRutas.route('/main').child('panel-control').child('gestion-emisoras').child('bloques', {
			name: 'Gestión de bloques',
			component: GestionBloquesComponent
		})

		misRutas.route('/main').child('panel-control').child('gestion-emisoras').child('contenidos', {
			name: 'Gestión de contenidos',
			component: GestionContenidosComponent
		})

		misRutas.route('/main').child('panel-control').child('gestion-emisoras').child('programas', {
			name: 'Gestión de programas',
			component: GestionProgramasComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-emisoras/vue/index.js